module.exports = __webpack_public_path__ + "img/矩形 30 拷贝 4@2x.eac73c51.png";